import { track } from '@fff-web/fff-analytics';
import { getQueryParam } from '../../MyAccount/utils/url';

export const UPGRADE_COMPLETED = 'Upgrade Completed';

const upgradeCompletedEvent = () => {
  const experience = getQueryParam('referrer');
  const properties = { cta_name: 'Upgrade', experience };
  track({ trackName: UPGRADE_COMPLETED, properties });
};

export default upgradeCompletedEvent;
